import {
  useEffect,
  useRef,
  type Dispatch,
  type SetStateAction,
} from "react";
import { formatDurationToHourMinute } from "../../../shared/utils/dateDrafts";
import type { ChallengeDetail } from "../../challenges/types/challengeAdmin";

type UseAdminChallengeScheduleDraftParams = {
  challengeDetail: ChallengeDetail | null;
  setChallengeDurationDraft: Dispatch<SetStateAction<string>>;
  setChallengeScheduledAtDraft: Dispatch<SetStateAction<Date | null>>;
  setChallengeScheduledEndAtDraft: Dispatch<SetStateAction<Date | null>>;
};

export function useAdminChallengeScheduleDraft({
  challengeDetail,
  setChallengeDurationDraft,
  setChallengeScheduledAtDraft,
  setChallengeScheduledEndAtDraft,
}: UseAdminChallengeScheduleDraftParams) {
  const lastChallengeIdRef = useRef<number | null>(null);

  useEffect(() => {
    const currentId = challengeDetail?.id ?? null;
    const lastId = (lastChallengeIdRef.current ?? null) as number | null;
    if (currentId === lastId) return;
    lastChallengeIdRef.current = currentId;
    if (!challengeDetail) {
      setChallengeScheduledAtDraft(null);
      setChallengeScheduledEndAtDraft(null);
      setChallengeDurationDraft("");
      return;
    }
    const scheduledDate = challengeDetail.scheduledAt
      ? new Date(challengeDetail.scheduledAt)
      : null;
    setChallengeScheduledAtDraft(
      scheduledDate && !Number.isNaN(scheduledDate.getTime())
        ? scheduledDate
        : null,
    );
    const scheduledEndDate = challengeDetail.scheduledEndAt
      ? new Date(challengeDetail.scheduledEndAt)
      : null;
    setChallengeScheduledEndAtDraft(
      scheduledEndDate && !Number.isNaN(scheduledEndDate.getTime())
        ? scheduledEndDate
        : null,
    );
    setChallengeDurationDraft(
      formatDurationToHourMinute(challengeDetail.durationSeconds || 0),
    );
  }, [
    challengeDetail,
    setChallengeDurationDraft,
    setChallengeScheduledAtDraft,
    setChallengeScheduledEndAtDraft,
  ]);
}
